const langMenu = () => {
  function openLangDropdown(openTrigger, subMenu) {
    openTrigger.setAttribute( 'aria-expanded', 'true' );
    openTrigger.setAttribute( 'aria-label', 'Taalkeuze openen' );
    subMenu.classList.add( 'active' );
  }

  function closeLangDropdown(openTrigger, subMenu) {
    openTrigger.setAttribute( 'aria-expanded', 'false' );
    openTrigger.setAttribute( 'aria-label', 'Taalkeuze sluiten' );
    subMenu.classList.remove( 'active' );
  }

  const langSwitchters = document.querySelectorAll( '.lang-switcher' );

  langSwitchters.length && langSwitchters.forEach( (item) => {
    const langDropdown = item.nextElementSibling;

    item.addEventListener( 'click', (event) => {
      if (item.getAttribute( 'aria-expanded' ) === 'false') {
        openLangDropdown( item, langDropdown )
      } else {
        closeLangDropdown( item, langDropdown );
      }
    } );
  } );

  document.addEventListener( 'click', (event) => {
    langSwitchters.forEach( (item) => {
      const langDropdown = item.nextElementSibling;

      if (!langDropdown.contains( event.target ) && !item.contains( event.target )) {
        closeLangDropdown( item, langDropdown );
      }
    } );
  } );

  document.addEventListener( 'keydown', (event) => {
    if (event.key === 'Escape') {
      langSwitchters.forEach( (item) => {
        const langDropdown = item.nextElementSibling;
        closeLangDropdown( item, langDropdown );
      } );
    }
  } );
}

export default langMenu;

